import { render, staticRenderFns } from "./fourColumnCard.vue?vue&type=template&id=4718db4c&scoped=true"
import script from "./fourColumnCard.vue?vue&type=script&lang=js"
export * from "./fourColumnCard.vue?vue&type=script&lang=js"
import style0 from "./fourColumnCard.vue?vue&type=style&index=0&id=4718db4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4718db4c",
  null
  
)

export default component.exports